import { render, staticRenderFns } from "./AfterTest.vue?vue&type=template&id=06583e0e&"
import script from "./AfterTest.vue?vue&type=script&lang=js&"
export * from "./AfterTest.vue?vue&type=script&lang=js&"
import style0 from "./AfterTest.vue?vue&type=style&index=0&media=screen&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/i554242/school/ocateszt/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VApp,VCard,VCardTitle,VContainer,VFlex,VLayout})
